import { Injectable } from '@angular/core';
import { IframeEmbedService } from './iframe-embed.service';
import { NavService } from './nav-service';

@Injectable()
export class SpinnerService {

  isShowing = false;
  message = '';
  styles: any = {};

  constructor(
    private readonly nav: NavService,
    private readonly iframeEmbed: IframeEmbedService,
  ) {}

  show(message: string = '') {
    if (message) {
      this.message = message;
    }
    this.isShowing = true;
    if (this.iframeEmbed.isIframeEmbed) {
      this.nav.updateHeaderComponent();
    }
  }

  hide() {
    this.isShowing = false;
    if (this.iframeEmbed.isIframeEmbed) {
      this.nav.updateHeaderComponent();
    }
  }

  setMessage(msg: string) {
    this.message = msg;
  }
}
